import { COMPANY, WHATSAPP } from "../config/company";

// The company's registered details, as CAC records them. Shown on the home
// page and /about; Meta's business verification reads them.
export function CompanyFacts() {
  return (
    <dl className="company__facts">
      <div>
        <dt>Legal business name</dt>
        <dd>{COMPANY.legalName}</dd>
      </div>
      <div>
        <dt>CAC registration number</dt>
        <dd className="mono">RC {COMPANY.rcNumber}</dd>
      </div>
      <div>
        <dt>Company type</dt>
        <dd>
          {COMPANY.companyType}, incorporated {COMPANY.incorporatedOn}
        </dd>
      </div>
      <div>
        <dt>Registered address</dt>
        <dd>{COMPANY.registeredAddress}</dd>
      </div>
      <div>
        <dt>Email</dt>
        <dd>
          <a href={`mailto:${COMPANY.supportEmail}`}>{COMPANY.supportEmail}</a>
        </dd>
      </div>
      <div>
        <dt>Phone</dt>
        <dd>
          <a href={`tel:${COMPANY.phone}`}>{COMPANY.phoneDisplay}</a>
        </dd>
      </div>
      <div>
        <dt>WhatsApp Business number</dt>
        <dd>
          {WHATSAPP.digits ? (
            <a href={WHATSAPP.href}>{WHATSAPP.display}</a>
          ) : (
            WHATSAPP.display
          )}
        </dd>
      </div>
      <div>
        <dt>Support hours</dt>
        <dd>
          The assistant is available 24/7. Human support: {COMPANY.supportHours}
          .
        </dd>
      </div>
      <div>
        <dt>Payment partners</dt>
        <dd>Card payments only, by Paystack. Bill fulfilment by VTpass.</dd>
      </div>
    </dl>
  );
}
